__webpack_require__.p = "../wp-content/plugins/wp-vue-quiz/dist/";